import React, { useState } from 'react';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import PostCard from '../components/PostCard';
import { Helmet } from "react-helmet";

function Home({ favorites, toggleFavorite }) {
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const posts = [
    {
      id: 1,
      title: 'Οι Καλύτερες Ασκήσεις για Δύναμη και Αντοχή',
      excerpt: 'Ανακαλύψτε τις πιο αποτελεσματικές ασκήσεις που θα μεταμορφώσουν το σώμα σας και θα αυξήσουν την αντοχή σας στο μέγιστο επίπεδο.',
      image: '/images/1.jpg',
      date: '15 Ιανουαρίου 2025',
      category: 'Προπόνηση'
    },
    {
      id: 2,
      title: 'Διατροφικός Οδηγός για Μέγιστη Απόδοση',
      excerpt: 'Μάθετε πώς να τρώτε σωστά για να επιτύχετε τους στόχους σας στο γυμναστήριο και να βελτιώσετε την υγεία σας.',
      image: '/images/2.jpg',
      date: '12 Ιανουαρίου 2025',
      category: 'Διατροφή'
    },
    {
      id: 3,
      title: 'Πώς να Χτίσετε Μυϊκή Μάζα Γρήγορα',
      excerpt: 'Τα μυστικά της γρήγορης ανάπτυξης μυϊκής μάζας με επιστημονικά αποδεδειγμένες μεθόδους και τεχνικές.',
      image: '/images/3.jpg',
      date: '10 Ιανουαρίου 2025',
      category: 'Μύες'
    },
    {
      id: 4,
      title: 'Καρδιοαναπνευστική Προπόνηση: Ο Πλήρης Οδηγός',
      excerpt: 'Όλα όσα πρέπει να γνωρίζετε για την καρδιοαναπνευστική προπόνηση και πώς να τη συνδυάσετε με την ενδυνάμωση.',
      image: '/images/4.jpg',
      date: '08 Ιανουαρίου 2025',
      category: 'Καρδιο'
    },
    {
      id: 5,
      title: 'Ανάκαμψη και Αποκατάσταση Μετά την Προπόνηση',
      excerpt: 'Τεχνικές και στρατηγικές για ταχύτερη ανάκαμψη, αποφυγή τραυματισμών και μέγιστη απόδοση στις προπονήσεις σας.',
      image: '/images/5.jpg',
      date: '05 Ιανουαρίου 2025',
      category: 'Ανάκαμψη'
    }
  ];

  const handleShare = (postId) => {
    setModalMessage('Η λειτουργία κοινοποίησης θα είναι σύντομα διαθέσιμη');
    setShowModal(true);
  };

  const handleFavorite = (postId) => {
    toggleFavorite(postId);
    const isFavorite = favorites.includes(postId);
    setModalMessage(isFavorite ? 'Αφαιρέθηκε από τα αγαπημένα' : 'Προστέθηκε στα αγαπημένα');
    setShowModal(true);
  };

  const handleAskQuestion = () => {
    setModalMessage('Η φόρμα ερωτήσεων θα είναι σύντομα διαθέσιμη. Παρακαλώ επισκεφθείτε τη σελίδα επικοινωνίας.');
    setShowModal(true);
  };

  return (
    <>
      <Helmet>
        <title>Ecunel Fitness Gym - Το Καλύτερο Blog για Fitness</title>
        <meta name="description" content="Καλώς Ήρθατε στο Ecunel Fitness Gym - Το πιο ολοκληρωμένο blog για fitness, υγεία και υγιεινή ζωή στην Ελλάδα. 
          Ανακαλύψτε επαγγελματικές συμβουλές" />
      </Helmet>

      <div>
      <section className="hero-section">
        <h2>Καλώς Ήρθατε στο Ecunel Fitness Gym</h2>
        <p>
          Το πιο ολοκληρωμένο blog για fitness, υγεία και fitness clubs υγιεινή ζωή στην Ελλάδα. 
          Ανακαλύψτε επαγγελματικές συμβουλές, προγράμματα προπόνησης και διατροφικούς οδηγούς.
        </p>
      </section>

      <section className="features-section">
        <div className="features-grid">
          <div className="feature-card">
            <FaStar className="feature-icon" />
            <h3>Επαγγελματικό Περιεχόμενο</h3>
            <p>
              Όλα τα άρθρα μας δημιουργούνται από πιστοποιημένους προπονητές και διατροφολόγους 
              με πολυετή εμπειρία στον χώρο του fitness classes.
            </p>
          </div>
          <div className="feature-card">
            <FaHeart className="feature-icon" />
            <h3>Προσωποποιημένες Συμβουλές</h3>
            <p>
              Λαμβάνετε εξατομικευμένες συμβουλές που ταιριάζουν στο επίπεδο και τους στόχους σας, 
              είτε είστε αρχάριοι είτε personal training near me προχωρημένοι αθλητές.
            </p>
          </div>
          <div className="feature-card">
            <FaShoppingCart className="feature-icon" />
            <h3>Ενημερωμένο Υλικό</h3>
            <p>
              Το περιεχόμενό μας ενημερώνεται συνεχώς με τις τελευταίες τάσεις και επιστημονικές 
              έρευνες στον χώρο της υγείας και του fitness.
            </p>
          </div>
          <div className="feature-card">
            <FaHome className="feature-icon" />
            <h3>Κοινότητα Υποστήριξης</h3>
            <p>
              Γίνετε μέλος της κοινότητάς μας και συνδεθείτε με άλλους ενθουσιώδεις του fitness 
              που μοιράζονται την ίδια πάθος γυμναστική με εσάς.
            </p>
          </div>
        </div>

        <div className="stats-section">
          <div className="stat-item">
            <span className="stat-number">5000+</span>
            <span className="stat-label">Ικανοποιημένοι Αναγνώστες</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">10+</span>
            <span className="stat-label">Χρόνια Εμπειρίας</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">500+</span>
            <span className="stat-label">Άρθρα Blog</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">Αφοσίωση</span>
          </div>
        </div>

        <div className="cta-section">
          <h3>Ξεκινήστε το Ταξίδι σας Σήμερα</h3>
          <p>
            Μην περιμένετε άλλο για να αλλάξετε τη ζωή σας. Διαβάστε τα άρθρα μας και ξεκινήστε 
            το ταξίδι προς μια πιο υγιή και δυνατή εκδοχή του εαυτού σας.
          </p>
        </div>
      </section>

      <section className="about-blog-section">
        <h2>Γιατί να Διαλέξετε το Ecunel Fitness Gym Blog</h2>
        <div className="about-blog-content">
          <p>
            Το <strong>Ecunel Fitness Gym Blog</strong> είναι ο απόλυτος προορισμός για όλους όσους επιθυμούν 
            να βελτιώσουν τη φυσική τους κατάσταση, να αποκτήσουν υγιεινές συνήθειες και να ζήσουν μια 
            ισορροπημένη ζωή. Με πάνω από μια δεκαετία εμπειρίας στον χώρο του fitness, η ομάδα μας 
            αποτελείται από πιστοποιημένους προπονητές, διατροφολόγους και ειδικούς υγείας που είναι 
            αφοσιωμένοι στο να σας παρέχουν το καλύτερο δυνατό περιεχόμενο.
          </p>
          <p>
            Κάθε άρθρο που δημοσιεύουμε βασίζεται σε <strong>επιστημονικές έρευνες</strong> και 
            <strong>πραγματική εμπειρία</strong>. Δεν προσφέρουμε απλώς θεωρία, αλλά πρακτικές λύσεις 
            που μπορείτε να εφαρμόσετε αμέσως στην καθημερινότητά σας. Είτε θέλετε να χάσετε βάρος, 
            να χτίσετε μυϊκή μάζα, να βελτιώσετε την αντοχή σας, ή απλά να υιοθετήσετε έναν πιο υγιεινό 
            τρόπο ζωής, εδώ θα βρείτε όλες τις απαντήσεις που χρειάζεστε.
          </p>
          <p>
            Η φιλοσοφία μας είναι απλή: <strong>πιστεύουμε ότι το fitness είναι για όλους</strong>. 
            Ανεξάρτητα από την ηλικία, το επίπεδο φυσικής κατάστασης ή τους στόχους σας, έχουμε 
            περιεχόμενο που θα σας βοηθήσει να πετύχετε. Από προγράμματα προπόνησης για αρχάριους 
            μέχρι προχωρημένες τεχνικές για έμπειρους αθλητές, καλύπτουμε όλο το φάσμα των αναγκών.
          </p>
          <p>
            Στο blog μας θα βρείτε <strong>αναλυτικούς οδηγούς προπόνησης</strong>, διατροφικά προγράμματα 
            προσαρμοσμένα στους στόχους σας, συμβουλές για ανάκαμψη και πρόληψη τραυματισμών, καθώς και 
            κίνητρο και έμπνευση για να συνεχίσετε το ταξίδι σας. Κάθε εβδομάδα δημοσιεύουμε νέο περιεχόμενο 
            που θα σας κρατήσει ενημερωμένους με τις τελευταίες τάσεις και επιστημονικές ανακαλύψεις στον 
            χώρο του fitness.
          </p>
          <p>
            Η <strong>κοινότητά μας</strong> είναι ένα από τα μεγαλύτερα πλεονεκτήματά μας. Πάνω από 5000 
            αναγνώστες μας εμπιστεύονται και ακολουθούν τις συμβουλές μας καθημερινά. Συνδεθείτε μαζί μας 
            στα social media, μοιραστείτε την πρόοδό σας και εμπνευστείτε από τις ιστορίες επιτυχίας άλλων 
            μελών της κοινότητας. Μαζί, μπορούμε να πετύχουμε περισσότερα από ό,τι μόνοι μας.
          </p>
          <p>
            Το Ecunel Fitness Gym Blog δεν είναι απλώς ένας ιστότοπος - είναι ένας <strong>σύντροφος στο 
            ταξίδι σας προς την καλύτερη εκδοχή του εαυτού σας</strong>. Ανεξάρτητα από το πού βρίσκεστε 
            τώρα, είμαστε εδώ για να σας υποστηρίξουμε σε γυμναστήριο κοντά μου κάθε βήμα. Ξεκινήστε σήμερα και δείτε τη διαφορά 
            που μπορεί να κάνει η σωστή καθοδήγηση στη ζωή σας.
          </p>
        </div>
      </section>

      <section className="posts-section">
        <h2>Τελευταία Άρθρα</h2>
        <div className="posts-grid">
          {posts.map(post => (
            <PostCard
              key={post.id}
              post={post}
              isFavorite={favorites.includes(post.id)}
              onToggleFavorite={handleFavorite}
              onShare={handleShare}
            />
          ))}
        </div>
      </section>

      <button className="ask-question-btn" onClick={handleAskQuestion}>
        Θέστε Ερώτηση
      </button>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Ειδοποίηση</h2>
            <p>{modalMessage}</p>
            <button className="btn btn-primary" onClick={() => setShowModal(false)}>
              Κλείσιμο
            </button>
          </div>
        </div>
      )}
    </div>
  
    </>);
}

export default Home;